import React, { useRef, useEffect } from "react";
import Masonry from "masonry-layout";

// Import widgets
import CustomerDetailsWidget from "../../../components/CustomerDashboard/CustomerDetailsWidget";
import LocationWidget from "../../../components/CustomerDashboard/LocationWidget";
import ProfileImageWidget from "../../../components/CustomerDashboard/ProfileImageWidget";
import LoginSecurityWidget from "../../../components/CustomerDashboard/LoginSecurityWidget";
import AccountClosureWidget from "../../../components/CustomerDashboard/AccountClosureWidget";

const CustAccount = ({ setFieldValue, values, errors }) => {
  // Masonry setup
  const masonryGridRef = useRef(null);
  useEffect(() => {
    if (masonryGridRef.current) {
      try {
        const images = masonryGridRef.current.querySelectorAll('img');
        const imagePromises = Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        });
        Promise.all(imagePromises).then(() => {
          if (masonryGridRef.current && typeof Masonry !== 'undefined') {
            const masonry = new Masonry(masonryGridRef.current, {
              itemSelector: '.masonry-item',
              columnWidth: 10,
              gutter: 0,
            });
            const handleResize = () => masonry && masonry.layout && masonry.layout();
            window.addEventListener('resize', handleResize);
            if (masonryGridRef.current) {
              masonryGridRef.current.masonry = masonry;
            }
            return () => {
              window.removeEventListener('resize', handleResize);
              if (masonryGridRef.current?.masonry) {
                masonryGridRef.current.masonry.destroy();
              }
            };
          }
        });
      } catch (e) {
        console.log('Masonry failed to init on customer account page:', e);
      }
    }
  }, []);

  return (
    <>
      <div className="w-full mx-auto">
        <div ref={masonryGridRef} className="masonry-grid">
          {/* Customer Account Widgets */}
          <CustomerDetailsWidget setFieldValue={setFieldValue} values={values} errors={errors} />
          <LoginSecurityWidget values={values} />
          <LocationWidget setFieldValue={setFieldValue} values={values} errors={errors} />
          <ProfileImageWidget errors={errors} />
          <AccountClosureWidget />
        </div>
      </div>
    </>
  );
};

export default CustAccount;
